import { ValidationErrors } from 'final-form';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { MarketplaceFormData } from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { OfferGroupFormData } from '~admin/view/components/details/offer-group-details/offer-group-fields.component';
import { validate, validateArrayField } from '~common/validator';
import {
  after,
  before,
  futureDateValidation,
  greaterThanZeroNumberValidation,
  nilOrGreaterThanZeroNumberValidation,
  required,
  urlPartialValidation,
} from '~common/validator/validations';

/**
 * Returns all validators for event details page
 * @param values
 */
export const createEventDetailsValidators = (
  values: EventFormData,
): ValidationErrors | undefined => ({
  clientId: validate(values.clientId, [required()]),
  ...validateArrayField(values, 'eventName', [required()]),
  eventLocationId: validate(values.eventLocationId, [required()]),
  avatarMedia: validate(values.avatarMedia, [required()]),
  defaultMedia: validate(values.defaultMedia, [required()]),
  emailMedia: validate(values.emailMedia, [required()]),
  landscapeVideo: validate(values.landscapeVideo, [required()]),
  eventDateTimeStart: validate(values.eventDateTimeStart, [
    required(),
    futureDateValidation(),
    after(values.eventDateTimeEnd),
  ]),
  eventDateTimeEnd: validate(values.eventDateTimeEnd, [
    required(),
    futureDateValidation(),
    before(values.eventDateTimeStart),
  ]),
  discoverDateStart: validate(values.discoverDateStart, [
    required(),
    futureDateValidation(),
    after(values.discoverDateEnd),
  ]),
  discoverDateEnd: validate(values.discoverDateEnd, [
    required(),
    futureDateValidation(),
    before(values.discoverDateStart),
  ]),
  doorsOpenDate: validate(values.doorsOpenDate, [required(), futureDateValidation()]),
  ticketLimit: validate(values.ticketLimit, [required()]),
  vanityName: validate(values.vanityName, [required(), urlPartialValidation]),
});

export const marketplaceValidators = (
  values: MarketplaceFormData[],
  eventDateTimeEnd: string,
): ValidationErrors[] =>
  values.map(
    ({
      type,
      ticketLimit,
      startDateTime,
      endDateTime,
      lowCapacityPercentageThreshold,
      timeToForceAllYoopAllocation,
      timeToStartPickingSeats,
      timeToForAllSeatAllocation,
    }: MarketplaceFormData): ValidationErrors => ({
      type: validate(type, [required()]),
      ticketLimit: validate(ticketLimit, [required(), greaterThanZeroNumberValidation()]),
      startDateTime: validate(startDateTime, [
        required(),
        futureDateValidation(),
        after(endDateTime),
      ]),
      endDateTime: validate(endDateTime, [
        required(),
        futureDateValidation(),
        before(startDateTime),
      ]),
      lowCapacityPercentageThreshold: validate(lowCapacityPercentageThreshold, [
        nilOrGreaterThanZeroNumberValidation(),
      ]),
      timeToForceAllYoopAllocation: validate(timeToForceAllYoopAllocation, [
        before(endDateTime),
        after(eventDateTimeEnd),
      ]),
      timeToStartPickingSeats: validate(timeToStartPickingSeats, [
        after(timeToForAllSeatAllocation),
      ]),
      timeToForAllSeatAllocation: validate(timeToForAllSeatAllocation, [
        before(timeToStartPickingSeats),
      ]),
    }),
  );

export const offerGroupValidators = (values: OfferGroupFormData[]): ValidationErrors[] =>
  values.map(
    (offerGroup: OfferGroupFormData): ValidationErrors => ({
      ...validateArrayField(offerGroup, 'name', [required()]),
      sections: offerGroup.sections.map((section) => validate(section, [required()])),
    }),
  );



// WEBPACK FOOTER //
// ./view/components/create-event/helper/create-event-validators.helper.ts